import { Button, Card } from "@design";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Text } from "@/components/Text";

/**
 * A run paused for a write action its owner must approve (MHS-972), not for a review: it's decided in the approvals
 * inbox, which only the run's owner sees.
 */
export function FlowRunAwaitingApproval({ isOwner }: Readonly<{ isOwner: boolean }>) {
  const { t } = useTranslation("workflows", { keyPrefix: "runs.awaitingApproval" });
  const navigate = useNavigate();
  return (
    <Card>
      <section className="flex flex-col gap-3" aria-label={t("title")}>
        <div className="flex flex-col gap-1">
          <Text variant="body">{t("title")}</Text>
          <Text variant="body-sm" tone="secondary">
            {isOwner ? t("bodyOwner") : t("bodyOther")}
          </Text>
        </div>
        {isOwner && (
          <div className="flex flex-wrap justify-end gap-2">
            <Button variant="primary" leadingIcon={<ShieldCheck size={14} />} onClick={() => navigate("/approvals")}>
              {t("open")}
            </Button>
          </div>
        )}
      </section>
    </Card>
  );
}
